// Dependencies
import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import nds from '@nerdwallet/base-styles/classes';

import { Heading } from '@nerdwallet/react-typography';

import VerticalSpacer from '../vertical-spacer/vertical-spacer';
import TextBox from '../text-box/text-box';

import { stringTextAreaSpec } from '../../lib/editing-configs';

const textAlignCenter = nds('text-align-center');

const TwoColText = ({ content, header, size }) => {
  const centerWhenSmall = size === 'sm' ? textAlignCenter : '';
  return (
    <div className="row-two-col__text">
      <Heading
        className={classNames(['row-two-col__text__header', centerWhenSmall])}
        level="3"
      >
        {header}
      </Heading>
      <VerticalSpacer mobile="p-18" tablet="p-18" desktop="p-18" />
      <TextBox
        className="row-two-col__text__content"
        textAlign={size === 'sm' ? 'center' : 'left'}
        text={content}
        copyStyle="copy-p1"
        parseLinks
      />
      <VerticalSpacer mobile="p-24" tablet="p-30" desktop="p-30" />
    </div>
  );
};

TwoColText.propTypes = {
  header: PropTypes.string,
  className: PropTypes.string,
  content: PropTypes.string,
  size: PropTypes.oneOf(['', 'sm', 'md', 'lg']),
};

TwoColText.defaultProps = {
  header: '',
  content: '',
};

TwoColText.getEditingConfig = () => [
  stringTextAreaSpec('header', 'Heading Text'),
  stringTextAreaSpec('content', 'Paragraph Text', {
    help: `Want a hyperlink? Write it like this: [Hi!](www.thing.com).
       NW links should be relative, e.g., [Home](/home)`,
  }),
];

TwoColText.displayName = 'TwoColText';

export default TwoColText;
